import { Fragment } from 'react'
import '../user.scss'

import UserTable from './UserTable'
import useTranslations from '../../../hooks/useTranslations'
import ANTDButton from '../../../shared/antd/ANTDButton'
import ANTDColumn from '../../../shared/antd/ANTDColumn'
import ANTDForm, { ANTDFormItem } from '../../../shared/antd/ANTDForm'
import ANTDModal from '../../../shared/antd/ANTDModal'
import ANTDRow from '../../../shared/antd/ANTDRow'
import getFormInput from '../../../shared/form.description'
import PopUpConfirm from '../../../shared/PopUpConfirm'
import { childUsers, userWiseRole } from '../../../utils/constant'
import { validationTag } from '../../../utils/customFunctions'
import { CloseOutlined } from '../../../utils/icons'
import {
  entries,
  include,
  isEqual,
  keys,
  length,
  ternary,
} from '../../../utils/javascript'
import { getItem } from '../../../utils/localstorage'
import UploadImage from '../../common/presentation/UploadImage'
import addUser from '../container/addUser.container'
import { addUserInitial } from '../user.description'

function AddUser({
  editInfo,
  setEditInfo,
  handleCancelEdit,
  isBuilding,
  userDetails,
  apiCall,
  addNewBuildData,
}) {
  const { t } = useTranslations()
  const {
    form,
    handleValuesChange,
    onFinish,
    handleAddEmail,
    handleRemoveEmail,
    fileList,
    setFileList,
    currentUserDescription,
    handleSelectClick,
    selectUser,
    handleSelectCancel,
    handleTableChange,
    onSelectUser,
    isSelect,
    formRoleId,
    handleSameAsParent,
    loader,
    handleSameAsCustomer,
    popup,
    handleClosePopup,
    userNewForm,
  } = addUser({
    t,
    editInfo,
    setEditInfo,
    handleCancelEdit,
    isBuilding,
    userDetails,
    apiCall,
    addNewBuildData,
  })
  const { fieldEngineer, dealerUser } = userWiseRole
  const lang = getItem('lang')

  return (
    <div className="m-5-percent">
      {!isBuilding && (
        <h2 className="mb-15">{t(currentUserDescription?.label)}</h2>
      )}
      <div>
        {currentUserDescription &&
        currentUserDescription?.parent &&
        !isBuilding &&
        !editInfo?.data?.id ? (
          <div>
            <h3 className="mb-10">
              {t(currentUserDescription?.parent?.label)}
            </h3>
            <UserTable
              {...{
                userData: {
                  loader: false,
                  list: length(keys(selectUser?.data))
                    ? [selectUser?.data]
                    : [],
                },
                permission: false,
                pagination: false,
              }}
            />
            {isSelect && (
              <h3
                className="text-end  mr-15 cursor-pointer primary-color"
                onClick={handleSelectClick}
              >
                {t('btn_Select')}
              </h3>
            )}
          </div>
        ) : null}
        <div className="mb-15 mt-10">
          {!isBuilding && (
            <UploadImage
              {...{
                acceptFileTypes: '.png,.jpg,.jpeg,.webp',
                uploadSingle: true,
                fileList,
                setFileList,
              }}
            />
          )}
        </div>
        {isBuilding && (
          <div className="text-end">
            <ANTDButton
              type="primary"
              className="btn mb-15"
              onClick={handleSameAsCustomer}
            >
              {t('btn_SameAsCustomer')}
            </ANTDButton>
          </div>
        )}
        <ANTDForm
          name="add-user"
          initialValues={addUserInitial}
          form={form}
          onValuesChange={handleValuesChange}
          onFinish={onFinish}
          layout="vertical"
        >
          {entries(userNewForm).map(([key, value]) => {
            const fieldComponent = (key, value, additionalLabel) => {
              const {
                label,
                validateTrigger,
                rules,
                md,
                sm,
                inputType,
                ...rest
              } = value
              const InputComponent = getFormInput({ inputType: inputType })
              const required = rules?.filter(v => v?.required)
              return (
                <ANTDColumn md={md} sm={sm} key={key}>
                  <ANTDFormItem
                    label={
                      additionalLabel
                        ? `${t(label)}${additionalLabel}`
                        : t(label)
                    }
                    name={key}
                    validateTrigger={validateTrigger}
                    rules={rules}
                    className={length(required) ? validationTag(lang) : ''}
                  >
                    <InputComponent {...rest} />
                  </ANTDFormItem>
                  {isEqual(value.label, 'user_Name') &&
                    include(childUsers, formRoleId) && (
                      <div className="text-end mb-10">
                        <ANTDButton type="primary" onClick={handleSameAsParent}>
                          {t('btn_SameAsParent')}
                        </ANTDButton>
                      </div>
                    )}
                </ANTDColumn>
              )
            }
            return (
              <ANTDRow gutter={10} key={key}>
                {include(['multipleRow1'], key)
                  ? entries(value).map(([k, v]) => {
                      return fieldComponent(k, v)
                    })
                  : isEqual(key, 'emailList')
                    ? value.map((item, i) => {
                        const newItem = {
                          ...item,
                          suffix:
                            length(value) > 1 ? (
                              <CloseOutlined
                                className="cursor-pointer"
                                onClick={() => handleRemoveEmail(i)}
                              />
                            ) : null,
                        }
                        return (
                          <Fragment key={i}>
                            {fieldComponent(
                              i ? `emailId${i}` : 'emailId',
                              newItem,
                              i,
                            )}
                            <ANTDColumn sm={24} ms={24} className="text-end">
                              {length(value) < 11 &&
                              isEqual(i, length(value) - 1) ? (
                                <ANTDButton
                                  type="primary"
                                  onClick={handleAddEmail}
                                >
                                  + {t('btn_AddMoreEmail')}
                                </ANTDButton>
                              ) : null}
                            </ANTDColumn>
                          </Fragment>
                        )
                      })
                    : ((editInfo?.data?.id || isBuilding) &&
                          include(['username', 'password'], key)) ||
                        (include([fieldEngineer, dealerUser], formRoleId) &&
                          include(['businessName'], key))
                      ? null
                      : fieldComponent(key, value)}
              </ANTDRow>
            )
          })}
          <ANTDRow className="">
            <ANTDColumn md={24} className="text-center">
              <ANTDButton
                loading={loader}
                type="primary"
                htmlType="submit"
                className="submit-btn"
              >
                {t(
                  ternary(
                    length(keys(editInfo?.data)),
                    'btn_Update',
                    'btn_Register',
                  ),
                )}
              </ANTDButton>
            </ANTDColumn>
          </ANTDRow>
        </ANTDForm>
      </div>
      <ANTDModal
        title={t('btn_Select')}
        open={selectUser?.flag}
        onCancel={handleSelectCancel}
        footer={null}
        width={1000}
      >
        <UserTable
          {...{
            isSearch: true,
            userData: selectUser?.list,
            permission: false,
            handleTableChange,
            payload: { roleId: currentUserDescription?.parent?.id },
            handleSelect: onSelectUser,
          }}
        />
      </ANTDModal>
      <PopUpConfirm
        isOpen={popup?.open}
        onCancelModel={handleClosePopup}
        description={popup?.message}
      />
    </div>
  )
}
export default AddUser
